import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getPlivosAPI } from "api/plivoAPI";

const handleThunkError = (err, rejectWithValue) => {
  return rejectWithValue(
    err?.response?.data || {
      success: false,
      message: "Something went wrong",
    }
  );
};

const initialState = {
  plivos: [],
  loading: false,
};

export const getPlivos = createAsyncThunk(
  "plivos/getPlivos",
  async (data, { rejectWithValue }) => {
    try {
      const response = await getPlivosAPI(data);
      return response.data;
    } catch (err) {
      console.log("get plivos error ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const plivoSlice = createSlice({
  name: "rates",
  initialState,
  reducers: {
    setPlivos: (state, action) => {
      console.log("YOYO, setPlivos", action.payload);
      state.plivos = action.payload;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getPlivos.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPlivos.fulfilled, (state, { payload }) => {
        state.plivos = payload.data;
        state.loading = false;
      })
      .addCase(getPlivos.rejected, (state) => {
        state.loading = false;
      }),
});

export const { setPlivos } = plivoSlice.actions;
export default plivoSlice.reducer;
